import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Button } from '@material-ui/core';
import Utils from '@/common/utils/utils';
// import csv upload element
import SelectFormName from './uploadCsvElements/SelectFormName';
import MappingForm from './uploadCsvElements/MappingForm';
import DownloadCommand from './uploadCsvElements/DownloadCommand';
import './KnowledgeTicket.css';
import { I18n } from 'aws-amplify';
import Constant from '@/common/constant/Constant';
import '../ticketList/knowledge/SettingPermissionKnowledgeTicket.css';
import KnowledgeInputFileUpload from './uploadCsvElements/KnowledgeInputFileUpload';
import WebCrawlerSetting from './uploadCsvElements/WebCrawlerSetting';
import {
    onKeyDown,
    handleOnPaste,
    createTicketByUploadCsv,
    checkIsDisabledStartButton,
    isDisabledAllFieldCsv,
    handleOpenLogScreen
} from './handler/KnowledgeUploadCsvHandler';
import {
    getFormFromFormListById,
    getListCustomFiledOfForm
} from '../ticketList/handler/TicketHandler';
import { getFormFieldData } from '../common/layout/addTicket/handler/AddTicketHandler';
import { TmpHiddenSysfieldInCreateTicket } from '../../common/constant/SystemField';
import LoadingPanel from '../common/LoadingPanel';
import { useRecoilState, useRecoilValue } from 'recoil';
import { handleStatusAtom, mappingCsv, selectedFormCsv } from '@/state/atom/knowledgeCsvAtom';
import { cloneDeep } from 'lodash';
import { corporationAtom } from '@/state/atom/corporationAtom';
import { projectInuseDetailAtom } from '@/state/atom/projectAtom';
import { userAtom } from '@/state/atom/userAtom';
import { useSnackbar } from 'notistack';
import { panelInitDataAtom } from '@/state/atom/panelAtom';
import { removePanelInitData, updatePanelInitData } from '../multiPanel/panel/handler/PanelHandler';
import DataChangePleaseReloadModal from '@/component/common/modal/DataChangePleaseReloadModal';
import { formListOfProjectSelector } from '@/state/selector/formSelector';
import { updateUserWorkLastForm } from '@/common/utils/ServiceFactoryUtil';

export default function KnowledgeUploadCsv({ API, panelId, tabId }) {
    // only use data method from parent props. NOT update function!
    const invalidCharsLimitValue = ['.', '-', '+', 'e', 'E', ',', '/'];
    const location = useLocation();
    const [csvContent, setCsvContent] = useState([]);
    const [totalLine, setTotalLine] = useState(0);
    const [errorList, setErrorList] = useState({});
    const [selectedFormDetail, setSelectedFormDetail] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [fieldListData, setFieldListData] = useState([]);
    const [listMapping, setListMapping] = useState([{ key: 0, value: I18n.get('KNOWCRLB034') }]);
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [upLoadKey, setupLoadKey] = useState('');
    const [isOpenModalReloadPage, setIsOpenModalReloadPage] = useState(false);

    // set textbox state
    const [currentLine, setCurrentLine] = useState(Constant.UPLOAD_CSV_KNOWLEDGE.MIN_CURRENT_LINE);
    const [layer, setLayer] = useState(Constant.UPLOAD_CSV_KNOWLEDGE.MIN_LAYER);
    const [fileTypes, setFileTypes] = useState(Constant.UPLOAD_CSV_KNOWLEDGE.FILE_TYPE_DEFAULT);
    const [password, setPassword] = useState('');
    const [userName, setUserName] = useState('');
    const [isDisabledPauseButton, setIsDisabledPauseButton] = useState(true);
    const [isEdited, setIsEdited] = useState(false);
    const [panelInitData, setPanelInitData] = useRecoilState(panelInitDataAtom);

    // atom 
    const corporationDetail = useRecoilValue(corporationAtom);
    const projectInuseDetail = useRecoilValue(projectInuseDetailAtom);
    const [userDetail, setUserDetail] = useRecoilState(userAtom);
    const [mapping, setMapping] = useRecoilState(mappingCsv);
    const selectedForm = useRecoilValue(selectedFormCsv);
    const [handleStatus, setHandleStatus] = useRecoilState(handleStatusAtom);
    const [firstLineUpload, setfirstLineUpload] = useState(0);
    const { enqueueSnackbar } = useSnackbar();
    const [selectedTypeImportCsv, setSelectedTypeImportCsv] = useState(
        Constant.UPLOAD_CSV_KNOWLEDGE.TYPE_IMPORT_CSV.NO_OVERWRITE
    );
    const [enableAutoCreateNewTagItem,setEnableAutoCreateNewTagItem] = useState(0)
    const [selectedOptionKnowledgeId, setSelectedOptionKnowledgeId] = useState('');
    
    const [listOptionsKnowledgeId, setListOptionsKnowledgeId] = useState([]);
    const [selectedUniqueField, setSelectedUniqueField] = useState({});
    const [listUniqueField, setListUniqueField] = useState([]);
    const [selectedUniqueCsv, setSelectedUniqueCsv] = useState('');
    const [formList, setFormList] = useRecoilState(formListOfProjectSelector);
    const [selectedAttachFile, setSelectedAttachFile] = useState(
        Constant.UPLOAD_CSV_KNOWLEDGE.TYPE_OVERWRITE_ATTACH_FILE.UPDATE
    );

    //delete-options
    const [selectDeleteMode, setSelectDeleteMode] = useState({ key: 0, value: I18n.get('KNOWCRLB034') });

    const [selectDeleteKey, setSelectDeleteKey] = useState({});
    const [listFieldInForm, setListFieldInForm] = useState([])

    const [selectCsvColumnName, setSelectCsvColumnName] = useState({});

    // Helper function to check if mcpServerSetting field should be displayed
    const isShowMCPServerSettingField = (formDetail) => {
        // Check form type FIRST (early return for performance)
        const isAIAutoForm = Utils.isSystemAIAutoForm(formDetail);
        const isChatAIPromptForm = Utils.isSystemFormChatAIPrompt(formDetail);
        const isSystemFormAIAssistantPrompt = Utils.isSystemFormAIAssistantPrompt(formDetail);

        
        // If not AI form, no need to check other conditions
        if (!isAIAutoForm && !isChatAIPromptForm && !isSystemFormAIAssistantPrompt) {
            return false;
        }
        
        // Check contract type PREMIUM
        if (corporationDetail?.contractType !== Constant.CORPORATION_CONTRACT_TYPE.PREMIUM) {
            return false;
        }
        
        // Check limitValue.mcpServer
        if (corporationDetail?.limitValue?.mcpServer !== Constant.STATUS_SERVICE_PERMISSION.ON) {
            return false;
        }
        
        // Check corporationSetting.usingMCPServer
        const corporationSetting = Utils.convertJSONDataToObject(corporationDetail?.corporationSetting);
        if (corporationSetting?.usingMCPServer !== Constant.STATUS_SERVICE_PERMISSION.ON) {
            return false;
        }
        
        return true;
    };

    //get init data
    useEffect(() => {
        (async () => {
            if (selectedForm) {
                setIsLoading(true);
                const formDetail = await getFormFromFormListById(selectedForm);
                setSelectedFormDetail(formDetail);
                if (!Utils.isEmptyObject(formDetail)) {
                    const formStructure = JSON.parse(formDetail?.structure);
                    const customFieldList = await getListCustomFiledOfForm(
                        formStructure,
                        API,
                        formDetail.affiliationOrganization
                    );
                    let getFieldListResult = getFormFieldData(formStructure, customFieldList);
                    getFieldListResult = Array.from(getFieldListResult, field => {
                        field.structure.publicForCustomer =
                            Constant.SETTING_FORM_DEFAULT.PUBLIC_FOR_CUSTOMER;
                        return field;
                    });

                    // Get field order in form
                    let fieldOrderInForm = {};
                    if (!Utils.isEmptyObject(formStructure)) {
                        for (const [structureKey, structureValue] of Object.entries(
                            formStructure
                        )) {
                            if (
                                structureKey &&
                                structureValue &&
                                structureValue.hasOwnProperty('field')
                            ) {
                                fieldOrderInForm[structureValue['field']] = parseInt(structureKey);
                            }
                        }
                    }
                    let getFieldListResultClone = getFieldListResult
                        .filter(
                            field =>
                                !field.sysField ||
                                !TmpHiddenSysfieldInCreateTicket.includes(field.sysField)
                        )
                        .sort((a, b) => {
                            if (!a.order || !b.order) return 1;
                            // attachment always at bottom
                            if (a.sysField === 'attachments') return 1;
                            if (b.sysField === 'attachments') return -1;

                            if (!Utils.isEmptyObject(fieldOrderInForm)) {
                                return fieldOrderInForm[a.id] - fieldOrderInForm[b.id];
                            }
                            return 1;
                        });

                    // Filter mcpServerSetting field based on conditions
                    let filteredFieldList = getFieldListResultClone;
                    if (!isShowMCPServerSettingField(formDetail)) {
                        filteredFieldList = getFieldListResultClone.filter(
                            field => field?.sysField !== Constant.AI_AUTO.SYSTEM_FIELD.MCP_SERVER_SETTING
                        );
                    };
                    
                    setFieldListData([...filteredFieldList]);

                    const listFieldType = [
                        Constant.FORM_TYPE.FIELD_TEXT,
                        Constant.FORM_TYPE.FIELD_INT,
                        Constant.FORM_TYPE.FIELD_FLOAT,
                        Constant.FORM_TYPE.FIELD_DATE,
                        Constant.FORM_TYPE.FIELD_DATE_TIME,
                        Constant.FORM_TYPE.FIELD_TIME,
                        Constant.FORM_TYPE.FIELD_TAG,
                        Constant.FORM_TYPE.FIELD_URL
                    ]

                    const listSysFieldNotShow = [
                        Constant.SYS_FIELD.ATTACHMENTS,
                        Constant.SYS_FIELD.SDAUTO_SCRIPT
                    ]

                    let mappingDataDefaults = {};
                    let listUniqueKeyField = [];

                    filteredFieldList?.forEach(field => {
                        mappingDataDefaults[field.id] =
                            Constant.UPLOAD_CSV_KNOWLEDGE.DEFAULT_SELECTED_MAPPING;
                        if (listFieldType.includes(field?.type) && !listSysFieldNotShow.includes(field?.sysField)) {
                            listUniqueKeyField.push(field);
                        }
                    });

                    setMapping(mappingDataDefaults);
                    setListUniqueField(listUniqueKeyField);

                    let getAllFieldInForm = Utils.sortByCreatedAtAsc(
                        getFieldListResult
                        .filter(field =>
                            !TmpHiddenSysfieldInCreateTicket
                                .filter(f => f !== 'ticketId')
                                .concat(listSysFieldNotShow)
                                .includes(field.sysField) 
                            && ![
                                    Constant.FORM_TYPE.FIELD_RICHTEXT,
                                    Constant.FORM_TYPE.FIELD_IFRAME,
                                    Constant.FORM_TYPE.MERMAID,
                                    Constant.FORM_TYPE.MARKDOWN
                                ].includes(field.type)
                        )
                    )
                    .map(field => {
                        if (field.sysField === 'ticketId') {
                            return {
                                ...field,
                                name: '{"jp":{"A":"F","text":"ナレッジID"}}'
                            };
                        }
                        return field;
                    })
                    .sort((a, b) => {
                        if (a.sysField === 'ticketId') return -1;
                        return 1;
                    });

                    setListFieldInForm([
                        ...getAllFieldInForm
                    ]);
                    
                }
                setIsLoading(false);
            }
        })();
    }, [selectedForm]);

    //submit form
    useEffect(() => {
        (async () => {
            if (handleStatus === Constant.UPLOAD_CSV_KNOWLEDGE.STATUS_START && upLoadKey) {
                setIsDisabledPauseButton(false);
                await handleLineCsv(currentLine);
            } else if (
                [
                    Constant.UPLOAD_CSV_KNOWLEDGE.STATUS_INITIAL,
                    Constant.UPLOAD_CSV_KNOWLEDGE.STATUS_PAUSE
                ].includes(handleStatus)
            ) {
                // do nothing
            }
        })();
    }, [currentLine, handleStatus]);

    // handle show popup confirm close panel when edited
    useEffect(() => {
        if (isEdited) {
            updatePanelInitData(
                panelId,
                tabId,
                panelInitData,
                setPanelInitData,
                'isEditedData',
                true
            );
        } else {
            removePanelInitData(
                panelId,
                tabId,
                panelInitData,
                setPanelInitData,
                'isEditedData',
                true
            );
        }
    }, [isEdited]);

    const handleStartProcess = async () => {
        // start form line 1
        setfirstLineUpload(currentLine);
        setupLoadKey(Utils.renderUploadKeys(uploadedFiles[0]?.name));
        setHandleStatus(Constant.UPLOAD_CSV_KNOWLEDGE.STATUS_START);

        let dataUpdateLastForm = {
            typeLastTicket: Constant.TYPE_LAST_FORM.LAST_FORM_KNOWLEDGE,
            formId: selectedForm,
            projectTargetId: projectInuseDetail?.id,
            corpTargetId: corporationDetail?.id
        }
    
        await updateUserWorkLastForm(dataUpdateLastForm, setUserDetail, userDetail);
    };

    const handlePauseProcess = () => {
        setHandleStatus(Constant.UPLOAD_CSV_KNOWLEDGE.STATUS_PAUSE);
    };

    const handleLineCsv = async line => {
        // index of array content csv
        const indexFromLine = line - Constant.UPLOAD_CSV_KNOWLEDGE.MIN_CURRENT_LINE;

        if (indexFromLine > csvContent.length) {
            handlePauseProcess();
            return;
        }

        const dataCsv = csvContent[indexFromLine];

        //pass data content csv to mapping
        let cloneMapping = cloneDeep(mapping);

        for (let field in mapping) {
            let keyForDataCsv = mapping[field];
            cloneMapping[field] = dataCsv[keyForDataCsv];
        }

        let settingCsv = {
            layer: layer,
            fileTypes: fileTypes,
            username: userName,
            password: password,
            selectedTypeImportCsv: selectedTypeImportCsv,
            selectedOptionKnowledgeId: dataCsv[selectedOptionKnowledgeId + 1],
            selectedUniqueField: selectedUniqueField,
            selectedUniqueCsv: dataCsv[selectedUniqueCsv + 1],
            selectedAttachFile: selectedAttachFile,
            isEnableAutoCreateTagItem: enableAutoCreateNewTagItem,
            
            selectDeleteModeValue: dataCsv[selectDeleteMode.key] || '',
            selectDeleteField: selectDeleteKey || {},
            selectDeleteCsvColumnValue: dataCsv[selectCsvColumnName.key + 1] || '',
        };
        
        let result = await createTicketByUploadCsv(
            API,
            cloneMapping,
            corporationDetail.id,
            projectInuseDetail.id,
            userDetail.id,
            selectedForm,
            settingCsv,
            currentLine,
            uploadedFiles[0]?.name,
            upLoadKey,
            totalLine,
            firstLineUpload
        );
        
        if (!result || (!result.status && result.isSkipUpload)) {
            handleStopUpload();
            if (result?.errorMessage === Constant.DATA_CHANGED_PLEASE_RELOAD_ERROR) {
                setIsOpenModalReloadPage(true);
            }
            return;
        }

        // if(result?.status) {
        //     let listTicket = Utils.convertJSONDataToObject(result.listTicket);

        //     if(!Utils.isEmptyArray(listTicket)) {
        //         setFormList(prevFormList => {
        //             let formListClone = cloneDeep(prevFormList);

        //             let formIndex = Utils.findIndexInArrayById(selectedForm, formListClone);
        //             if(formIndex !== -1) {
        //                 let formDetail = formListClone[formIndex];
        //                 let usingTickets = Utils.convertJSONDataToObject(formDetail.usingTickets);

        //                 for(let newTicket of listTicket) {
        //                     if (!Utils.isEmptyObject(usingTickets)) {
        //                         if (usingTickets[newTicket.affiliationProject]) {
        //                             usingTickets[newTicket.affiliationProject].push(newTicket.id);
        //                         } else {
        //                             usingTickets[newTicket.affiliationProject] = [newTicket.id];
        //                         }
        //                     } else {
        //                         usingTickets = {};
        //                         usingTickets[newTicket.affiliationProject] = [newTicket.id];
        //                     }
        //                 }

        //                 formListClone[formIndex].usingTickets = JSON.stringify(usingTickets);
        //             }
        //             return formListClone;
        //         });
        //     }
        // }

        const nextLine = Number(line) + 1;
        if (nextLine - 1 > csvContent.length) {
            handleStopUpload();
            enqueueSnackbar(I18n.get('KNOWCRMSG005'), {
                variant: 'success',
                autoHideDuration: 3000
            });
            return;
        }
        setCurrentLine(nextLine);
    };

    const handleStopUpload = () => {
        handlePauseProcess();
        setHandleStatus(Constant.UPLOAD_CSV_KNOWLEDGE.STATUS_SUCCESS);
        setIsDisabledPauseButton(true);
        setfirstLineUpload(0);
    }

    const handleChangeCurrentLine = e => {
        let value = e.target.value;
        const regex = /[^\p{Script=Latin}\p{N}]/u;

        if (regex.test(value)) {
            e.preventDefault();
            // Ngăn người dùng nhập ký tự tiếng Nhật và các ký tự fullwidth, halfwidth khác số
        } else {
            // Xử lý giá trị nhập liệu hợp lệ
            setIsEdited(true);
            setCurrentLine(parseInt(value));
        }
    };

    const onBlurCurrentLine = e => {
        let value = e.target.value;
        if (
            (value < Constant.UPLOAD_CSV_KNOWLEDGE.MIN_CURRENT_LINE && value) ||
            Utils.isEmptyString(value)
        ) {
            return setCurrentLine(Constant.UPLOAD_CSV_KNOWLEDGE.MIN_CURRENT_LINE);
        }
        if (value > totalLine) {
            return setCurrentLine(totalLine);
        }

        setCurrentLine(value.replace(/^0+/, ''));
    };

    const renderNameButtonStart = () => {
        let name = I18n.get('KNOWCRBTN006');
        switch (handleStatus) {
            case Constant.UPLOAD_CSV_KNOWLEDGE.STATUS_SUCCESS:
                name = '完了'
                break;
            case Constant.UPLOAD_CSV_KNOWLEDGE.STATUS_START:
            case Constant.UPLOAD_CSV_KNOWLEDGE.STATUS_PAUSE:
                name = I18n.get('KNOWCRLB033');
                break;
            case Constant.UPLOAD_CSV_KNOWLEDGE.STATUS_INITIAL:
                name = I18n.get('KNOWCRBTN006')
                break;
            default:
                name = I18n.get('KNOWCRBTN006');
                break;
        }
        return name;
    }

    if (!selectedForm) {
        return <></>;
    }

    const isShowBtnDownloadCommand = () => {
        if (Utils.isGuestContractType(corporationDetail)) {
            const inviterSettingObject = Utils.convertJSONDataToObject(corporationDetail?.inviterSetting)
            return inviterSettingObject.batchCommandService ? true : false;
        } else {
            let limitValue = corporationDetail.limitValue;
            return limitValue?.batchCommandService ? true : false;
        }

    }

    return (
        <div className="knowledge-upload-csv">
            <LoadingPanel isLoading={isLoading} />

            <SelectFormName selectedFormInfo={selectedFormDetail} />

            {/* process line / total line */}
            <div className="process-line">
                <div className="left">
                    <div>{I18n.get('KNOWCRLB003')}</div>
                    <div>
                        {!Utils.isEmptyArray(uploadedFiles) ? (
                            <form
                                autoComplete="off"
                                autocorrect="off"
                                onSubmit={e => e.preventDefault()}
                            >
                                <input
                                    autocorrect="off"
                                    id="current-line-id"
                                    disabled={isDisabledAllFieldCsv(handleStatus)}
                                    className="process-line-input"
                                    type="number"
                                    value={currentLine}
                                    onChange={handleChangeCurrentLine}
                                    onBlur={onBlurCurrentLine}
                                    onWheel={e => e.target.blur()}
                                    onKeyDown={e => onKeyDown(e, invalidCharsLimitValue)}
                                    onPaste={e => handleOnPaste(e, invalidCharsLimitValue)}
                                    autoComplete="new-password"
                                />
                            </form>
                        ) : (
                            Constant.UPLOAD_CSV_KNOWLEDGE.DEFAULT_LINE
                        )}
                    </div>
                    <div className="total-line">/&nbsp;{`${totalLine}`}</div>
                </div>
                <img
                    src="/assets/image/process-upload-csv.svg"
                    alt=""
                    onClick={() => handleOpenLogScreen(`${location.pathname}/log-screen`)}
                />
            </div>

            <div className="groupBtn-handle-upload">
                {/* out of scope  */}
                <div className="groupBtn-preview"></div>
                {/* <div className="groupBtn-preview">
                    <Button
                        variant="text"
                        startIcon={<ChevronLeftIcon />}
                        className="btn-back btn-common"
                        disabled
                    >
                        {I18n.get('KNOWCRBTN001')}
                    </Button>
                    <Button variant="outlined" className="btn-preview btn-common" disabled>
                        {I18n.get('KNOWCRBTN003')}
                    </Button>
                    <Button
                        variant="text"
                        endIcon={<ChevronRightIcon />}
                        className="btn-next btn-common"
                        disabled
                    >
                        {I18n.get('KNOWCRBTN002')}
                    </Button>
                </div> */}

                <div className="groupBtn-pause-save">
                    {/* out of scope  */}
                    {/* <Button
                        className="btn-pause btn-outline-primary btn-hg32"
                        variant="contained"
                        color="primary"
                        disabled={isDisabledPauseButton}
                        onClick={handlePauseProcess}
                    >
                        {I18n.get('KNOWCRBTN004')}
                    </Button> */}

                    <Button
                        className={`${
                            checkIsDisabledStartButton(
                                errorList,
                                mapping,
                                handleStatus,
                                selectedTypeImportCsv,
                                selectedOptionKnowledgeId,
                                selectedUniqueField,
                                selectedUniqueCsv
                            )
                                ? 'btn-send-disabled'
                                : 'btn-send'
                        } btn-hg32`}
                        variant="outlined"
                        onClick={handleStartProcess}
                        disabled={checkIsDisabledStartButton(
                            errorList,
                            mapping,
                            handleStatus,
                            selectedTypeImportCsv,
                            selectedOptionKnowledgeId,
                            selectedUniqueField,
                            selectedUniqueCsv
                        )}
                    >
                        {renderNameButtonStart()}
                    </Button>
                </div>
            </div>

            <div className="scrollable mainWrap">
                {/* //web crawler component  */}
                <WebCrawlerSetting
                    layer={layer}
                    setLayer={setLayer}
                    setErrorList={setErrorList}
                    errorList={errorList}
                    fileTypes={fileTypes}
                    setFileTypes={setFileTypes}
                    password={password}
                    setPassword={setPassword}
                    userName={userName}
                    setUserName={setUserName}
                    handleStatus={handleStatus}
                    setIsEdited={setIsEdited}
                />

                {/* upload csv component  */}
                <KnowledgeInputFileUpload
                    setErrorList={setErrorList}
                    errorList={errorList}
                    setCurrentLine={setCurrentLine}
                    setTotalLine={setTotalLine}
                    setCsvContent={setCsvContent}
                    setListMapping={setListMapping}
                    setMapping={setMapping}
                    mapping={mapping}
                    listMapping={listMapping}
                    uploadedFiles={uploadedFiles}
                    setUploadedFiles={setUploadedFiles}
                    handleStatus={handleStatus}
                    setHandleStatus={setHandleStatus}
                    setIsEdited={setIsEdited}
                    setSelectedOptionKnowledgeId={setSelectedOptionKnowledgeId}
                    setListOptionsKnowledgeId={setListOptionsKnowledgeId}
                    setSelectedUniqueCsv={setSelectedUniqueCsv}
                    setSelectDeleteMode={setSelectDeleteMode}
                    setSelectDeleteKey={setSelectDeleteKey}
                    setSelectCsvColumnName={setSelectCsvColumnName}
                />

                {/* mapping field  */}
                <MappingForm
                    selectedForm={selectedForm}
                    mapping={mapping}
                    setMapping={setMapping}
                    fieldListData={fieldListData}
                    listMapping={listMapping}
                    handleStatus={handleStatus}
                    setIsEdited={setIsEdited}
                    setSelectedTypeImportCsv={setSelectedTypeImportCsv}
                    selectedTypeImportCsv={selectedTypeImportCsv}
                    selectedOptionKnowledgeId={selectedOptionKnowledgeId}
                    setSelectedOptionKnowledgeId={setSelectedOptionKnowledgeId}
                    listOptionsKnowledgeId={listOptionsKnowledgeId}
                    listUniqueField={listUniqueField}
                    selectedUniqueField={selectedUniqueField}
                    setSelectedUniqueField={setSelectedUniqueField}
                    selectedUniqueCsv={selectedUniqueCsv}
                    setSelectedUniqueCsv={setSelectedUniqueCsv}
                    selectedAttachFile={selectedAttachFile}
                    setSelectedAttachFile={setSelectedAttachFile}
                    enableAutoCreateNewTagItem = {enableAutoCreateNewTagItem}
                    setEnableAutoCreateNewTagItem = {setEnableAutoCreateNewTagItem}
                    
                    // delete-setting
                    selectDeleteMode={selectDeleteMode}
                    setSelectDeleteMode={setSelectDeleteMode}

                    selectDeleteKey={selectDeleteKey}
                    setSelectDeleteKey={setSelectDeleteKey}
                    listFieldInForm={listFieldInForm}
                    
                    selectCsvColumnName={selectCsvColumnName}
                    setSelectCsvColumnName={setSelectCsvColumnName}
                />

                {/* Download command  */}
                {isShowBtnDownloadCommand() && (
                <DownloadCommand />

                )}

                <DataChangePleaseReloadModal
                    isOpen={isOpenModalReloadPage}
                    setIsOpen={setIsOpenModalReloadPage}
                />
            </div>
        </div>
    );
}
